import React from 'react';
import PropTypes from 'prop-types';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import InputGroupV2 from '../InputGroupV2';
import {
  pickerOpenButtonSlotProps,
  pickerTextFieldSlotProps,
} from '../formFieldStyles';
import moment from 'moment';
import 'moment/locale/pt-br';

moment.locale('pt-br');

const DateTimePickerV2 = ({
  onChange,
  value,
  label,
  disabled,
  isRequired,
  error,
}) => (
  <InputGroupV2 label={label} isRequired={isRequired}>
    <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale="pt-br">
      <DateTimePicker
        format="DD/MM/YYYY HH:mm"
        value={
          value && typeof value !== 'function' ? moment(value) : null
        }
        onChange={(v) => onChange(v ? v.valueOf() : null)}
        disabled={disabled}
        ampm={false}
        slotProps={{
          openPickerButton: pickerOpenButtonSlotProps,
          textField: pickerTextFieldSlotProps({
            disabled,
            error,
            helperText: 'Data é obrigatória',
          }),
        }}
      />
    </LocalizationProvider>
  </InputGroupV2>
);

DateTimePickerV2.propTypes = {
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.number,
  disabled: PropTypes.bool,
  isRequired: PropTypes.any,
  error: PropTypes.bool,
};

DateTimePickerV2.defaultProps = {
  disabled: false,
  isRequired: false,
  error: false,
};

export default DateTimePickerV2;
